import { useEffect, useState } from "react";

export default function HealthCheck() {
  const [logoOk, setLogoOk] = useState<null | boolean>(null);

  useEffect(() => {
    fetch("/fyrris-logo.png", { method: "HEAD" })
      .then((r) => setLogoOk(r.ok))
      .catch(() => setLogoOk(false));
  }, []);

  const supaUrl = import.meta.env.VITE_SUPABASE_URL;
  const supaKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

  // 🔒 Hide overlay in production
  if (import.meta.env.MODE === "production") return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: 8,
        right: 8,
        zIndex: 9999,
        background: "#111827",
        color: "#e5e7eb",
        padding: "8px 10px",
        borderRadius: 8,
        fontSize: 12,
        boxShadow: "0 2px 8px rgba(0,0,0,.3)",
      }}
    >
      <div>logo: {logoOk === null ? "…" : logoOk ? "OK" : "MISSING"}</div>
      <div>VITE_SUPABASE_URL: {supaUrl ? "set" : "missing"}</div>
      <div>VITE_SUPABASE_ANON_KEY: {supaKey ? "set" : "missing"}</div>
    </div>
  );
}
